/**
 * @module hotornot/config/routes
 */
import {main} from '../../core/service/location.js';
import {path, createMany, index, alias, expr, on} from '@acng/frontend-voyager';
import {onlyUser} from 'acng/userPool/config/middleware';
import {trackOncePerMinute} from 'acng/userPool/service/activity.js';
import {mainView, stickyView} from 'acng/layout/service/sequence.js';
import {feature} from '../service/template.js';

main.create(
  onlyUser,
  path('/hotornot'), //
  alias('hotOrNotBase'),
  on('active', trackOncePerMinute),
  createMany(
    [index, alias('hotOrNot')], //
    [path('/votes'), mainView(feature, 'votes'), stickyView(feature, 'list-header')],
    [path('/matches'), mainView(feature, 'matches'), stickyView(feature, 'list-header')],
  ),
);
